import axios from 'axios';
import envVar from '../envVar.json'

const API = axios.create({
    baseURL: envVar.apiURL,
});
export default API;